function FindMediaSrc(product) {
  let end = false,
    indexs = [],
    mediaSrc = [],
    count = -1;
  let productPics = [];
  if (product.medias != "") {
    for (let i = 0; end == false; i++) {
      let temp = product.medias.indexOf("@@", count + 1);
      if (i >= 1) {
        if (temp == -1) end = true;
        else {
          indexs[i] = temp;
          count = indexs[i];
        }
      } else {
        indexs[i] = temp;
        count = indexs[i];
      }
    }
  }
  if (indexs.length > 0) {
    let first = 0,
      lastIndex = 0;
    for (let i = 0; i < indexs.length + 1; i++) {
      mediaSrc[i] = product.medias.slice(first, indexs[i]);
      first = indexs[i] + 2;
      lastIndex = i;
    }
    mediaSrc[lastIndex + 1] = product.coverImg;
  } else {
    mediaSrc[0] = product.coverImg;
  }
  for (let i = 0; i < mediaSrc.length; i++) {
    productPics[i] = {
      src: mediaSrc[i],
    };
  }
  return productPics;
}
export default FindMediaSrc;
